export default __webpack_public_path__ + "static/media/html.f318c8b1.svg";